/* Motion system — scroll-triggered reveals (progressive enhancement).
 * Hides + observes only elements fully below viewport at init time.
 * No JS / no IO / reduced motion => no class changes, full visibility.
 */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = '.featured-product-section, ' +
                 '.resource-list[data-testid="resource-list-grid"], ' +
                 '.facebook-community, ' +
                 '.editorial-split';

  function init() {
    var targets = document.querySelectorAll(SELECTOR);
    if (!targets.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;

    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('motion-pending');
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top > vh) {
        el.classList.add('motion-pending');
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
